import { useMutation, useQueryClient } from "@tanstack/react-query";
import client from "api/graphql/getClient";
import { graphql } from "gql/gql";
import { CreateResolverWebhookParams } from "gql/graphql";
import { useActiveAccount } from "utils/useActiveAccount";

const createResolverWebhookDocument = graphql(/* GraphQL */ `
	mutation createResolverWebhook($params: CreateResolverWebhookParams!) {
		createResolverWebhook(params: $params) {
			resolver_webhook {
				_id
				account_id
				url
				name
				headers {
					key
					value
				}
				created
				updated
				user_id
				disabled
			}
			error {
				code
				message
			}
			success
		}
	}
`);

interface Args {
	params: CreateResolverWebhookParams;
	userId?: string;
}

const createResolverWebhook = ({ params, userId }: Args) =>
	client(userId)
		.request(createResolverWebhookDocument, { params })
		.then((res) => res.createResolverWebhook);

const useCreateResolverWebhook = () => {
	const { userId, _id } = useActiveAccount();
	const queryClient = useQueryClient();

	return useMutation(
		(params: CreateResolverWebhookParams) =>
			createResolverWebhook({ params, userId }),
		{
			onSettled: () =>
				queryClient.invalidateQueries([
					"user",
					userId,
					"account",
					_id,
					"resolverWebhooks",
				]),
		}
	);
};

export default useCreateResolverWebhook;
